module.exports = __webpack_public_path__ + "img/star_fill.0e32af24.svg";